module.exports = __webpack_public_path__ + "static/media/pics1.7f032d24.png";